/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * the application scope as used in the X-Application-Scope header
 * @export
 */
export const ApplicationScope = {
    MyDb: 'MY_DB'
} as const;
export type ApplicationScope = typeof ApplicationScope[keyof typeof ApplicationScope];


export function ApplicationScopeFromJSON(json: any): ApplicationScope {
    return ApplicationScopeFromJSONTyped(json, false);
}

export function ApplicationScopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplicationScope {
    return json as ApplicationScope;
}

export function ApplicationScopeToJSON(value?: ApplicationScope | null): any {
    return value as any;
}

